import styled from '@emotion/styled';

export const Place = styled.div`
  padding: 15px 0 0;
`;
